import axios from 'axios';

// Base URL for the API
const API = axios.create({ baseURL: 'https://pilatesnflow.onrender.com/' }); // Base URL for all APIs //({ baseURL: 'http://localhost:5000/' })// 

// Register API
export const register = async (userData) => {

    try {
        const response = await API.post('/users/register', userData); // POST /users/register
        return response;
    } catch (error) {
        console.error('Error in register API:', error.response?.data || error.message);
        throw error;
    }
};

// Login API
export const login = async (userData) => {

    try {
        const response = await API.post('/users/login', userData); // POST /users/login
        return response;
    } catch (error) {
        console.error('Error in login API:', error.response?.data || error.message);
        throw error;
    }
};

// Logout API
export const logout = async (username) => {
    try {
        const response = await API.post('/users/logout', { username }); // POST /users/logout
        return response;
    } catch (error) {
        console.error('Error in logout API:', error.response?.data || error.message);
        throw error;
    }
};

export const updateUserRole = async (data) => {
    try {
        const response = await API.post('/users/update-role', data);
        return response;
    } catch (error) {
        throw error;
    }
};
export const updateUserEmail = async (userId) => {
    try {
        const response = await API.post(`/users/update-emailVerified/${userId}`);
        return response;
    } catch (error) {
        throw error;
    }
};
export const uploadImage = async (formData) => {
    try {
        const response = await API.post('/users/addImage', formData, {
            headers: { 'Content-Type': 'multipart/form-data' },
        });
        return response.data;
    } catch (error) {
        console.error('Error in uploadImage API:', error.response?.data || error.message);
        throw error;
    }
};

// Get Program API
export const getImage = async (userId) => {
    try {
        const response = await API.get(`/users/getImage/${userId}`);
        return response.data;
    } catch (error) {
        console.error('Error in getImage API:', error.response?.data || error.message);
        return false;
    }
};

// Get Weight Progress API
export const getUsernameById = async (userId) => {
    try {
        const response = await API.get(`/users/getUsername/${userId}`); // GET /users/getUsername/:userId
        return response.data;
    } catch (error) {
        console.error('Error in getUsernameById API:', error.response?.data || error.message);
        throw error;
    }
};

export const getUserById = async (userId) => {
    try {
        const response = await API.get(`/users/getUser/${userId}`); // GET /users/getUser/:userId
        return response.data;
    } catch (error) {
        console.error('Error in getUserById API:', error.response?.data || error.message);
        throw error;
    }
};

export const changePassword = async (username, currentPassword, newPassword) => {
    try {
        const response = await API.post('/users/change-password', {
            username,
            currentPassword,
            newPassword,
        });
        return response.data;
    } catch (error) {
        console.error('Error in changePassword API:', error.response?.data || error.message);
        throw error;
    }
};

export const forgotPassword = async (email) => {
    try {
        const response = await API.post(`/users/forgot-password/${email}`);
        return response.data;
    } catch (error) {
        console.error('Error in forgotPassword API:', error.response?.data || error.message);
        throw error;
    }
};

// Assume this API function exists (to be added in backend)
export const getTraineesByTrainerId = async (trainerId) => {
    try {
        const response = await API.get(`/users/trainees/${trainerId}`);
        return response.data;
    } catch (error) {
        console.error('Error fetching trainees:', error.response?.data || error.message);
        throw error;
    }
};

// Add Weight API
export const addWeight = async (userId, weight) => {
    try {
        const response = await API.post('/weights/add', { userId, weight }); // POST /weights/add
        return response.data;
    } catch (error) {
        console.error('Error in addWeight API:', error.response?.data || error.message);
        throw error;
    }
};

// Get Weight Progress API
export const getWeightProgress = async (userId) => {
    try {
        const response = await API.get(`/weights/progress/${userId}`); // GET /weights/progress/:userId
        return response.data;
    } catch (error) {
        console.error('Error in getWeightProgress API:', error.response?.data || error.message);
        throw error;
    }
};

// Add Program API
export const addProgram = async (formData) => {
    try {
        const response = await API.post('/programs/add', formData, {
            headers: { 'Content-Type': 'multipart/form-data' },
        });
        return response.data;
    } catch (error) {
        console.error('Error in addProgram API:', error.response?.data || error.message);
        throw error;
    }
};

// Get Program API
export const getProgram = async (userId) => {
    try {
        const response = await API.get(`/programs/getProgram/${userId}`); // GET /programs/:userId
        return response.data;
    } catch (error) {
        console.error('Error in getProgram API:', error.response?.data || error.message);
        throw error;
    }
};

export const addGalleryVideo = async (formData, onUploadProgress) => {
    try {
        const response = await API.post('/galleries/add', formData, {
            headers: { 'Content-Type': 'multipart/form-data' },
            onUploadProgress: (progressEvent) => {
                const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
                onUploadProgress(percentCompleted);
            },
        });
        return response.data;
    } catch (error) {
        console.error('Error in addGalleryVideo API:', error.response?.data || error.message);
        throw error;
    }
};

export const getGalleryVideos = async (userId, mediaType) => {
    try {
        const response = await API.get(`/galleries/getVideos/${userId}?mediaType=${mediaType}`);
        return response.data;
    } catch (error) {
        console.error('Error in getGalleryVideos API:', error.response?.data || error.message);
        throw error;
    }
};

export const streamVideo = async (fileId) => {
    try {
        const response = await API.get(`/galleries/stream/${fileId}`, {
            responseType: 'blob',
        });
        return response.data;
    } catch (error) {
        console.error('Error in streamVideo API:', error.response?.data || error.message);
        throw error;
    }
};

export const deleteGalleries = async (galleryId) => {
    try {
        const response = await API.delete(`/galleries/delete/${galleryId}`);

        return response.data;
    } catch (error) {
        console.error('Error in deleteGalleries API:', error.response?.data || error.message);
        throw error;
    }
};

export const checkAdminApi = async (userId) => {
    try {
        const response = await API.get(`/users/getAdminRole/${userId}`);
        return response.data.isAdmin; // Return true/false based on the response
    } catch (error) {
        console.error('Error in checkAdmin API:', error.response?.data || error.message);
        return false; // Return false if there's an error (assuming non-admin if error occurs)
    }
};

export const checkTrainerApi = async (userId) => {
    try {
        const response = await API.get(`/users/getTrainerRole/${userId}`);
        return response.data.isTrainer; // Return true/false based on the response
    } catch (error) {
        console.error('Error in checkTrainer API:', error.response?.data || error.message);
        return false; // Return false if there's an error (assuming non-admin if error occurs)
    }
};

export const addMeal = async (userId, food, mealType) => {
    try {
        const response = await API.post('/foods/add', {
            userId, food, mealType
        });
        return response.data;
    } catch (error) {
        console.error('Error in addMeal in API:', error.response?.data || error.message);
        throw error;
    }
};

export const deleteMeal = async (userId, mealId) => {
    try {
        const response = await API.delete(`/foods/delete/${userId}/${mealId}`);
        return response.data;
    } catch (error) {
        console.error('Error in deleteMeal API:', error.response?.data || error.message);
        throw error;
    }
};

export const getMeal = async (userId) => {
    try {
        const response = await API.get(`/foods/getMeal/${userId}`);
        return response.data;
    } catch (error) {
        console.error('Error in getMeal API:', error.response?.data || error.message);
        throw error;
    }
};

export const addGoal = async (userId, caloricGoal) => {
    try {
        const response = await API.post('/goals/add', {
            userId, caloricGoal
        });
        return response.data;
    } catch (error) {
        console.error('Error in addGoal in API:', error.response?.data || error.message);
        throw error;
    }
};

export const deleteGoal = async (userId) => {
    try {
        const response = await API.delete(`/goals/delete/${userId}`);
        return response.data;
    } catch (error) {
        console.error('Error in deleteGoal API:', error.response?.data || error.message);
        throw error;
    }
};

export const getGoal = async (userId) => {
    try {
        const response = await API.get(`/goals/getGoal/${userId}`);
        return response.data;
    } catch (error) {
        console.error('Error in getGoal API:', error.response?.data || error.message);
        throw error;
    }
};

export const addAd = async (formData) => {
    try {
        const response = await API.post('/ads/add', formData, {
            headers: { 'Content-Type': 'multipart/form-data' },
        });
        return response.data;
    } catch (error) {
        console.error('Error in addAd API:', error.response?.data || error.message);
        throw error;
    }
};

// Get Program API
export const getAd = async (userId) => {
    try {
        const response = await API.get(`/ads/getAd/${userId}`);
        return response.data;
    } catch (error) {
        console.error('Error in getAd API:', error.response?.data || error.message);
        throw error;
    }
};

// In your utils/api.js file
export const deleteAd = async (adId) => {
    try {
        const response = await API.delete(`/ads/delete/${adId}`);
        return response.data;
    } catch (error) {
        console.error('Error in deleteAd API:', error.response?.data || error.message);
        throw error;
    }
};

export const addStories = async (formData, onUploadProgress) => {
    try {
        const response = await API.post('/stories/add', formData, {
            headers: { 'Content-Type': 'multipart/form-data' },
            onUploadProgress: (progressEvent) => {
                const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
                onUploadProgress(percentCompleted);
            },
        });
        return response.data;
    } catch (error) {
        console.error('Error in addStories API:', error.response?.data || error.message);
        throw error;
    }
};

// Get Program API
export const getStories = async (userId) => {
    try {
        const response = await API.get(`/stories/getStories/${userId}`);
        return response.data;
    } catch (error) {
        console.error('Error in getStories API:', error.response?.data || error.message);
        throw error;
    }
};

export const deleteStories = async (storyId) => {
    try {
        const response = await API.delete(`/stories/delete/${storyId}`);
        return response.data;
    } catch (error) {
        console.error('Error in deleteStory API:', error.response?.data || error.message);
        throw error;
    }
};

export const addRecipe = async (recipe) => {
    try {
        const response = await API.post('/recipes/add', recipe);
        return response.data;
    } catch (error) {
        console.error('Error in addRecipe in API:', error.response?.data || error.message);
        throw error;
    }
};


export const getRecipe = async (userId) => {
    try {
        const response = await API.get(`/recipes/getRecipe`);
        return response.data;
    } catch (error) {
        console.error('Error in getRecipe API:', error.response?.data || error.message);
        throw error;
    }
};

export const fetchWebExercises = async () => {
    try {
        const response = await API.get('/exercises/ fetchWebExercises');
        return response.data;
    } catch (error) {
        console.error('Error fetching from web:', error.response?.data || error.message);
        throw error;
    }
};

export const getExercises = async () => {
    try {
        const response = await API.get('/exercises/getExercises');
        return response.data;
    } catch (error) {
        console.error('Error fetching exercises:', error.response?.data || error.message);
        throw error;
    }
};

export const getExerciseById = async (id) => {
    try {
        const response = await API.get(`/exercises/getExercise/${id}`);
        return response.data;
    } catch (error) {
        console.error('Error fetching exercise by id:', error.response?.data || error.message);
        throw error;
    }
};

export const getExercisesByMuscleGroup = async (muscleGroup) => {
    try {
        const response = await API.get(`/exercises/getExercisesByMuscleGroup/${muscleGroup}`);
        return response.data;
    } catch (error) {
        console.error('Error fetching exercises by muscle group:', error.response?.data || error.message);
        throw error;
    }
};

export const addLinks = async (userId, linksData) => {
    try {
        const response = await API.post(`/links/add/${userId}`, linksData);
        return response.data;
    } catch (error) {
        console.error('Error in updateLinks API:', error.response?.data || error.message);
        throw error;
    }
};

export const getLinksByUserId = async (userId) => {
    try {
        const response = await API.get(`/links/getLink/${userId}`);
        return response.data;
    } catch (error) {
        console.error('Error in getLinksByUserId API:', error.response?.data || error.message);
        throw error;
    }
};

export const updateLinks = async (userId, linksData) => {

    try {
        const response = await API.post(`/links/update/${userId}`, linksData);
        return response.data;
    } catch (error) {
        console.error('Error in updateLinks API:', error.response?.data || error.message);
        throw error;
    }
};

export const sendVerificationCode = async (userId, phone) => {
    try {
        const response = await API.post(`/users/send-verification-code/${userId}`, { phone });
        return response.data;
    } catch (error) {
        console.error('Error in sendVerificationCode API:', error.response?.data || error.message);
        throw error;
    }
};

export const verifyPhone = async (userId, code, phone) => {
    try {
        const response = await API.post(`/users/verify-phone/${userId}`, { code, phone });

        return response.data;
    } catch (error) {
        console.error('Error in verifyPhone API:', error.response?.data || error.message);
        throw error;
    }
};

export const saveWorkoutProgram = async (programData) => {
    try {
        const response = await API.post('/workoutProgram/add', programData, {
            headers: { 'Content-Type': 'application/json' },
        });
        return await response.data;
    } catch (error) {
        console.error('Error in saveworkoutProgram API:', error.response?.data || error.message);
        throw error;
    }
};
// utils/api.js
export const getWorkoutProgram = async (programId) => {
    const response = await API.get(`/workoutProgram/get/${programId}`);
    return response.data;
};

export const updateWorkoutProgram = async (programId, programData) => {
    const response = await API.put(`/workoutProgram/update/${programId}`, programData);
    return response.data;
};

export const updateProgramByWorkoutProgramId = async (workoutProgramId, formData) => {
    const response = await API.put(`/programs/updateByWorkoutProgramId/${workoutProgramId}`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
    });
    return response.data;
};
// utils/api.js
export const getNotifications = async (userId) => {
    try {
        const response = await API.get(`/notifications/${userId}`);
        return response.data;
    } catch (error) {
        console.error('Error in getNotifications API:', error.response?.data || error.message);
        throw error;
    }
};

// utils/api.js
export const updateNotification = async (notificationId, isRead) => {
    try {
        const response = await API.post(`/notifications/update/${notificationId}`, isRead);
        return response.data;
    } catch (error) {
        console.error('Error in updateNotification API:', error.response?.data || error.message);
        throw error;
    }
};
export const deleteNotification = async (notificationId) => {
    try {
        const response = await API.delete(`/notifications/${notificationId}`);
        return response.data;
    } catch (error) {
        console.error('Error in deleteNotification API:', error.response?.data || error.message);
        throw error;
    }
};
export const setNotificationDays = async (userId, days) => {
    try {
        const response = await API.put('/users/setNotificationDays', { userId, days });
        return response.data;
    } catch (error) {
        console.error('Error setting notification days:', error);
        throw error;
    }
};
export const subscribeToPush = async (userId, subscription) => {
    const response = await API.post(`/pushes/subscribe/${userId}`, subscription);
    if (response.status !== 201) {
        const data = await response.json();
        throw new Error(data.message || 'Failed to subscribe to push notifications');
    }
    const data = await response.data;
    return data;
};
export const buyCopun = async (userId, coins) => {
    try {
        const response = await API.post(`/users/buyCopun/${userId}`, { coins });
        return response.data;
    } catch (error) {
        console.error('Error buying copun API:', error);
        throw error;
    }
};
export const addCopun = async (copunCode, discountAmount) => {
    try {
        const response = await API.post(`/copuns/addCopun`, { copunCode, discountAmount });
        return response.data;
    } catch (error) {
        console.error('Error adding coupon API:', error);
        throw error;
    }
};

export const getCopun = async (copunCode) => {
    try {
        const response = await API.get(`/copuns/getCopun`, { copunCode });
        return response.data;
    } catch (error) {
        console.error('Error getting coupon API:', error);
        throw error;
    }
};

export const getCurrentCopunByDiscount = async (discountAmount) => {
    try {
        const response = await API.get(`/copuns/getCurrentCopunByDiscount`, { params: { discountAmount } });
        return response.data;
    } catch (error) {
        console.error('Error getting current coupon by discount API:', error);
        throw error;
    }
};

export const saveNutritionPlan = async (userId, planData) => {
    try {
        const response = await API.post('/nutrition/save', { userId, planData });
        return response.data;
    } catch (error) {
        console.error('Error in saveNutritionPlan API:', error.response?.data || error.message);
        throw error;
    }
};

export const getNutritionPlans = async (userId) => {
    try {
        const response = await API.get(`/nutrition/get/${userId}`);
        return response.data;
    } catch (error) {
        console.error('Error in getNutritionPlans API:', error.response?.data || error.message);
        throw error;
    }
};

export const updateNutritionPlan = async (planId, mealId, consumed) => {
    try {
        const response = await API.put(`/nutrition/update/${planId}`, { mealId, consumed });
        return response.data;
    } catch (error) {
        console.error('Error in updateNutritionPlan API:', error.response?.data || error.message);
        throw error;
    }
};
// utils/api.js
export const addNutritionPDF = async (formData) => {
    try {
        const response = await API.post('/nutrition/add-pdf', formData, {
            headers: { 'Content-Type': 'multipart/form-data' }
        });
        return response.data;
    } catch (error) {
        console.error('Error in addNutritionPDF API:', error.response?.data || error.message);
        throw error;
    }
};